module.exports = __webpack_public_path__ + "img/3.c32262be.jpg";